export const API_CACHE_KEYS = {
  PERSON: 'person',
  GLOBAL_ROLE_ASSIGNMENTS: 'global_role_assignments',
  FEATURES: 'features',
  PUSH_CATEGORIES: 'push-categories',
  SUGGESTION_CATEGORIES: 'suggestion_categories',
  // Onboarding Status
  ONBOARDING_STATUS: 'onboarding_status',
  ONBOARDING_STATUS_INITIAL: 'onboarding_status_initial',
  GRAPEVINE_ONBOARDING_STATUS: 'grapevine_onboarding_status',
  // Legal
  LEGAL_TEXTS: 'legal_texts',
  LEGAL_TEXT_STATUS: 'legal_text_status',
  // Organizations
  ORGANIZATIONS: 'organizations',
  ORGANIZATION: 'organization',
  ORGANIZATION_MEMBERS: 'organization_members',
  OWN_ORGANIZATIONS: 'own_organizations',
  ORGANIZATIONS_IN_GEO_AREA: 'organizations_in_geo_area',
  ORGANIZATIONS_IN_OWN_GEO_AREA_SELECTION:
    'organizations_in_own_geo_area_selection',
  CREATABLE_ORGANIZATION_TYPES: 'creatable_organization_types',
  TERRITORIAL_AUTHORITY: 'territorial_authority',
  STATISTICS_EMAIL_CONFIG: 'statistics_email_config',
  ORGANIZATION_COMMENT_PUSH_SETTING: 'organization_comment_push_setting',
  // Conveniences
  CONVENIENCES: 'conveniences',
  CONVENIENCE: 'convenience',
  // Geo Area
  GEO_AREA: 'geo_area',
  GEO_AREA_PROFILE: 'geo_area_profile',
  GEO_AREAS: 'geo_areas',
  AVAILABLE_GEO_AREAS: 'available_geo_areas',
  SEARCH_AVAILABLE_GEO_AREAS: 'search_available_geo_areas',
  NEAREST_GEO_AREA: 'nearest_geo_area',
  SELECTED_GEO_AREAS: 'selected_geo_areas',
  GEOCODE_SEARCH: 'geocode_search',
  GEOCODE_REVERSE: 'geocode_reverse',
  // Groups
  GROUP: 'group',
  GROUPS: 'groups',
  GROUP_POSTS: 'group_posts',
  // Group Members
  PENDING_MEMBERS: 'pending_members',
  GROUP_ADMINS: 'group_admins',
  GROUP_MEMBERS: 'group_members',
  // Posts
  POST: 'post',
  POST_CREATION_OPTIONS: 'post_creation_options',
  POST_FEED: 'post_feed',
  MEIN_ORT_POST_FEED: 'mein_ort_post_feed',
  SAGS_UNS_POST_FEED: 'sags_uns_post_feed',
  POSTS_BY_GEO_AREAS: 'posts_by_geo_areas',
  MINISTRY_POST_FEED: 'ministry_post_feed',
  POSTS_BY_GEO_AREA: 'posts_by_geo_area',
  MY_REGION_EVENTS_FEED: 'my_region_events_feed',
  REGIONALFUNK_POST_FEED: 'regionalfunk_post_feed',
  EMERGENCY_POST_FEED: 'emergency_post_feed',
  POST_FEED_LIMITED: 'post_feed_limited',
  POST_SEARCH: 'post_search',
  OWN_POSTS: 'own_posts',
  OWN_POSTS_WITH_ACTIVITY: 'own_posts_with_activity',
  ORGANIZATION_POSTS: 'organization_posts',
  ORGANIZATION_POSTS_WITH_ACTIVITIES: 'organization_posts_with_activities',
  HAPPENING_PARTICIPANTS: 'happening_participants',
  // Post Comments
  COMMENTS: 'comments',
  COMMENT: 'comment',
  // Chats
  OWN_CHATS: 'own_chats',
  CHAT: 'chat',
  CHAT_MESSAGES: 'chat_messages',
  PENDING_CHAT_MESSAGES: 'pending_chat_messages'
} as const;
